import React from 'react';

import { useContentRequirementsContext } from 'src/application/features/RestrictNavigation/ContentRequirementsProvider';

import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { useGetMultipleAssetUrls } from '../../hooks/useGetMultipleAssetUrls';
import { ExistingStudentWidgetProps } from '../Widget';
import { FlipCard } from './FlipCard';
import { FlipCardType, FlipCardWidget as FlipCardWidgetModel, WidgetType } from '@ael/core-api';

export const FlipCardWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const flipCardWidget = (widget as FlipCardWidgetModel).value;
  const { submitWidget, fulfilled } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);

  const [, setFlippedCards] = React.useState<boolean[]>(new Array(flipCardWidget.data?.cards.length).fill(false));

  const handleFlip = (index: number) => {
    if (fulfilled === false && flipCardWidget.properties.isRequired) {
      setFlippedCards((prev) => {
        const newFlippedCards = [...prev];
        newFlippedCards[index] = true;
        if (newFlippedCards.every((flipped) => flipped)) {
          fulfillCurrentWidget();
        }
        return newFlippedCards;
      });
    }
  };

  const assetIds = flipCardWidget.data.cards
    .flatMap((card) => [
      card.front.type === FlipCardType.imageFull ? card.front.assetId : null,
      card.back.type === FlipCardType.imageFull ? card.back.assetId : null,
    ])
    //unique assetIds
    .filter((value, index, array) => array.indexOf(value) === index)
    //remove nulls
    .filter((assetId): assetId is string => assetId !== null);

  const { getAssetUrlForAssetIndex } = useGetMultipleAssetUrls(widget._id, WidgetType.flipCard, assetIds);

  return (
    <StudentWidgetWrapper>
      <div className="uno-flex uno-flex-row uno-justify-center uno-flex-wrap uno-gap-8 ">
        {flipCardWidget.data?.cards.map((flipCard, index) => (
          <FlipCard
            widgetId={widget._id}
            key={index}
            model={flipCard}
            getAssetUrl={(assetId) => getAssetUrlForAssetIndex(assetIds.indexOf(assetId))}
            onFlipped={() => handleFlip(index)}
          />
        ))}
      </div>
    </StudentWidgetWrapper>
  );
};
